import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "highcharts/highcharts-more";
import "highcharts/modules/solid-gauge";

const ScanByChart = ({ selectRoleId, setRoleId, roleList, scanByUserData }) => {
  const colorMapping = {
    genuine: "#19BB4D",
    cross_selling: "#FDBE4A",
    counterfeit: "#FE3838",
  };

  console.log("scanByUserData", scanByUserData )
  const total = scanByUserData?.total_count || 0;
  const dynamicData = [
    {
      name: "Genuine",
      y: total === 0 ? 0 : (scanByUserData?.genuine / total) * 100,
      color: colorMapping.genuine,
    },
    {
      name: "Cross Selling",
      y: total === 0 ? 0 : (scanByUserData?.cross_selling / total) * 100,
      color: colorMapping.cross_selling,
    },
    {
      name: "Counterfeit",
      y: total === 0 ? 0 : (scanByUserData?.counterfeit / total) * 100,
      color: colorMapping.counterfeit,
    },
  ];

  const options = {
    chart: {
      type: "solidgauge",
      height: 300,
      backgroundColor: "transparent",
    },
    title: {
      text: scanByUserData?.total_count || 0,
      align: "center",
      verticalAlign: "middle",
      y: 5,
      style: {
        fontSize: "20px",
        fontWeight: "bold",
      },
    },
    tooltip: {
      enabled: true,
      shared: false,
      useHTML: true,
      outside: false,
      formatter: function () {
        const countMapping = {
          Genuine: scanByUserData?.genuine ?? 0,
          "Cross Selling": scanByUserData?.cross_selling ?? 0,
          Counterfeit: scanByUserData?.counterfeit ?? 0,
        };
      
        const cleanName = this.series.name.replace("-bg", "");
      
        const count = countMapping[cleanName] ?? 0;
        return `${cleanName}: <b>${count}</b>`;
      },
    },

    subtitle: {
      text: "Total",
      align: "center",
      verticalAlign: "middle",
      y: 25,
      style: {
        color: "#666",
      },
    },
    pane: {
      startAngle: 0,
      endAngle: 360,
      background: [],
    },

    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: [],
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          enabled: false,
        },
        linecap: "round",
        stickyTracking: false,
      },
    },
    series: [],
  };

  dynamicData.forEach((item, i) => {
    const thickness = 18;
    const gap = 2;
    const outerRadius = `${100 - i * (thickness + gap)}%`;
    const innerRadius = `${100 - i * (thickness + gap) - thickness}%`;

    // Background series (gray part)
    options.series.push({
      name: `${item.name}-bg`,
      data: [
        {
          color: "#E6E6E6",
          radius: outerRadius,
          innerRadius: innerRadius,
          y: 100,
        },
      ],
      enableMouseTracking: true,
      linkedTo: `:${item.name}`, // Link to the colored series
      states: {
        hover: {
          enabled: false,
          brightness: 0,
          halo: {
            size: 0
          }
        },
        inactive: {
          opacity: 1
        }
      },
      dataLabels: { enabled: false }
    });

    // Colored series
    options.series.push({
      id: item.name, // Add id for linking
      name: item.name,
      data: [
        {
          color: total === 0 ? item.color : item.color,
          radius: outerRadius,
          innerRadius: innerRadius,
          y: item.y,
        },
      ],
      states: {
        hover: {
          enabled: true,
          brightness: 0.1
        },
        inactive: {
          opacity: 0.5
        }
      },
      dataLabels: { enabled: false }
    });
  });

  return (
    <div style={{ position: "relative" }}>
      <select
        value={selectRoleId}
        onChange={(e) => setRoleId(e.target.value)}
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          marginBottom: "10px",
          padding: "5px",
          zIndex: 1,
        }}
      >
        {roleList.map((data) => (
          <option key={data.id} value={data.id}>
            {data.name}
          </option>
        ))}
      </select>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default ScanByChart;
